import React from "react";
import CreditCardForm from "./CreditCardForm";
import numeral from "numeral";
import ErrorHelper from "../Errors/ErrorHelper";

export default class BookingPaymentMethod extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (this.props.payment_method && this.props.payment_method.payment_token) {
      return (
        <div className="cards">
          <p>
            <a href="#" onClick={this.props.onClearPaymentMethod}>
              {I18n.t("remove")}
            </a>
          </p>
          <span
            className={
              "credit-card-icon small " +
              this.props.payment_method.payment_token.card.brand
            }
          ></span>
          <strong>
            {I18n.t(this.props.payment_method.payment_token.card.brand)}
          </strong>{" "}
          {I18n.t("ending_in").toLowerCase()}{" "}
          <strong>{this.props.payment_method.payment_token.card.last4}</strong>
        </div>
      );
    } else if (
      this.props.guest_information &&
      this.props.guest_information.id &&
      this.props.guest_information.cards &&
      this.props.guest_information.cards.length > 0
    ) {
      var cards = this.props.guest_information.cards.map(function (card) {
        return (
          <div
            className={
              "card well " +
              (self.props.card_id == card.id ? "card-selected" : "")
            }
            key={card.id}
          >
            <label>
              <input
                type="radio"
                name="card_id"
                value={card.id}
                checked={self.props.card_id == card.id}
                onChange={self.props.onChange}
              />
              <span className={"credit-card-icon small " + card.brand}></span>
              <strong>{I18n.t(card.brand)}</strong>{" "}
              {I18n.t("ending_in").toLowerCase()} <strong>{card.last_4}</strong>
            </label>
          </div>
        );
      });

      return (
        <div
          className="PaymentMethod"
          style={{ marginLeft: "-15px", marginRight: "-15px" }}
        >
          <p>
            <a href="#" onClick={this.props.onToggleAddNewCard}>
              {I18n.t(
                this.props.add_new_card_visible
                  ? "use_existing_cards"
                  : "add_new_card"
              )}
            </a>
          </p>
          {this.props.add_new_card_visible ? (
            <CreditCardForm
              card={{ ...this.props.payment_method }}
              saveCard={true}
              customer={this.props.guest_information}
              callSource={"bookingWidget"}
              onChangeCardInput={this.props.onChangePaymentMethod}
              hasClassErrors={this.hasClassErrors}
              renderFieldErrors={this.renderFieldErrors}
              disableNameOnCard={this.props.disableNameOnCard}
              onResetCardElement={this.props.onResetCardElement}
              cardInputWidth="col-sm-7"
              nameOnCardInputWidth="col-sm-5"
              stackedForm={true}
            />
          ) : (
            <div className="cards">{cards}</div>
          )}
          {!this.props.voucher ? (
            <p
              className="open-close-voucher"
              style={{ marginLeft: "15px", marginRight: "15px" }}
            >
              <a href="#" onClick={this.props.toggleVoucherInput}>
                {I18n.t(
                  !this.props.displayVoucherInput ? "redeem_voucher" : "close"
                )}
              </a>
            </p>
          ) : null}
          {this.renderRedeemVoucher()}
        </div>
      );
    } else {
      return (
        <div
          className="PaymentMethod"
          style={{ marginLeft: "-15px", marginRight: "-15px" }}
        >
          <CreditCardForm
            card={this.props.payment_method}
            saveCard={true}
            customer={this.props.guest_information}
            callSource={"bookingWidget"}
            onChangeCardInput={this.props.onChangePaymentMethod}
            hasClassErrors={this.hasClassErrors}
            renderFieldErrors={this.renderFieldErrors}
            disableNameOnCard={this.props.disableNameOnCard}
            displayCardResetButton={this.props.disableNameOnCard}
            onResetCardElement={this.props.onResetCardElement}
            cardInputWidth="col-sm-7"
            nameOnCardInputWidth="col-sm-5"
            stackedForm={true}
          />
          {!this.props.voucher ? (
            <p
              className="open-close-voucher"
              style={{ marginLeft: "15px", marginRight: "15px" }}
            >
              <a href="#" onClick={this.props.toggleVoucherInput}>
                {I18n.t(
                  !this.props.displayVoucherInput ? "redeem_voucher" : "close"
                )}
              </a>
            </p>
          ) : null}
          {this.renderRedeemVoucher()}
        </div>
      );
    }
  }

  renderRedeemVoucher = () => {
    if (this.props.displayVoucherInput && !this.props.voucher) {
      return (
        <div className="voucher-wrapper">
          <div className="row">
            <div className="form-group col-md-5">
              <label>{I18n.t("redemption_code")}</label>
              <input
                className={
                  ErrorHelper.renderFieldClasses(
                    "expiration_date",
                    this.props.voucherErrors
                  ) +
                  " " +
                  ErrorHelper.renderFieldClasses(
                    "balance",
                    this.props.voucherErrors
                  ) +
                  " " +
                  ErrorHelper.renderFieldClasses(
                    "redemption_code",
                    this.props.voucherErrors
                  ) +
                  " " +
                  ErrorHelper.renderFieldClasses(
                    "void",
                    this.props.voucherErrors
                  )
                }
                name="redemption_code"
                value={this.props.voucherInputValue}
                onChange={this.props.onChangeVoucherInput}
              />
              {this.props.voucherErrors
                ? ErrorHelper.renderFieldErrors(
                    "expiration_date",
                    this.props.voucherErrors
                  )
                : null}
              {this.props.voucherErrors
                ? ErrorHelper.renderFieldErrors(
                    "redemption_code",
                    this.props.voucherErrors
                  )
                : null}
              {this.props.voucherErrors
                ? ErrorHelper.renderFieldErrors(
                    "balance",
                    this.props.voucherErrors
                  )
                : null}
              {this.props.voucherErrors
                ? ErrorHelper.renderFieldErrors(
                    "void",
                    this.props.voucherErrors
                  )
                : null}
            </div>
          </div>
          <div className="row">
            <div className="col-md-2">
              <button
                className="btn  btn-primary "
                onClick={this.props.getVoucher}
              >
                {I18n.t("enter")}
              </button>
            </div>
          </div>
        </div>
      );
    } else if (
      this.props.voucher &&
      this.props.voucher.redemption_code &&
      this.props.voucher.balance
    ) {
      return (
        <div className="redeemed-voucher-wrapper">
          <div className="row">
            <div className="form-group col-md-5">
              <label>{I18n.t("redemption_code")}</label>
              <div>{this.props.voucher.redemption_code}</div>
            </div>

            <div className="form-group col-md-3">
              <label>{I18n.t("balance")}</label>
              <div>{this.formatCurrency(this.props.voucher.balance)}</div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-2">
              <button
                className="btn  btn-primary enter-voucher-code"
                onClick={this.props.removeVoucher}
              >
                {I18n.t("remove")}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  renderFieldErrors = (braketReference) => {
    if (
      this.props.paymentErrors &&
      this.props.paymentErrors.field_errors &&
      this.props.paymentErrors.field_errors[braketReference]
    ) {
      return (
        <div className="help-block">
          <ul>
            <li>
              <b>&#x2022;</b>
              {this.props.paymentErrors.field_errors[braketReference]}
            </li>
          </ul>
        </div>
      );
    }
  };

  hasClassErrors = (braketReference) => {
    if (
      this.props.paymentErrors &&
      this.props.paymentErrors.field_errors &&
      this.props.paymentErrors.field_errors[braketReference]
    ) {
      return true;
    } else {
      return false;
    }
  };

  formatCurrency = (num) => {
    return (
      I18n.t("number.currency.format.unit") +
      numeral(num / 100).format(
        "0" + I18n.t("number.currency.format.delimiter") + "0.00"
      )
    );
  };
}
